/**
 * CSV types supported by the backend.
 */
export enum CsvType {
  CSV = 'CSV',
  CSV_FIN = 'CSV_FIN',
  COMPANY_SPECIFIC = 'COMPANY_SPECIFIC',
  DATE_SPECIFIC = 'DATE_SPECIFIC'
}
